function categorySliderInit() {
	$(".category-slider").slick({
		arrows: false,
		infinite: true,
		slidesToShow: 3,
		autoplay: true,
		autoplaySpeed: 5000,
		responsive: [
			{
				breakpoint: 1023,
				settings: {
					slidesToShow: 2,
				},
			},
			{
				breakpoint: 479,
				settings: {
					slidesToShow: 1,
				},
			},
		],
	});

	$("[data-category-slide='next']").on("click", function() {
		$(".category-slider").slick("slickNext");
	});
	$("[data-category-slide='prev']").on("click", function() {
		$(".category-slider").slick("slickPrev");
	});
}
